/**
 * Function to make delay
 * @param {number} ms delay ms value
 * @param {boolean} reject Is need reject after delay, default false
 * @returns {Promise<void>}
 */
const delay = (ms, reject = false) => new Promise((res, rej) => setTimeout(reject ? rej : res, ms));
export default delay;
